export default __webpack_public_path__ + "static/media/T_White.13c9855f.png";